import { Navigate } from 'react-router-dom';
import { useFeatureFlags } from '../hooks/useFeatureFlags';

/**
 * Wraps a route element. If the named feature is disabled, redirects to /dashboard.
 * While flags are loading, renders children (no flash of redirect).
 */
export default function FeatureGate({ feature, children }) {
  const { isFeatureEnabled, isLoading } = useFeatureFlags();

  // While loading, show content to avoid flash
  if (isLoading) return children;

  if (!isFeatureEnabled(feature)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
